import {
    API_BASE_URL,
    DATA_USER_DATA_KEY,
    DATA_ACCESS_TOKEN,
    PATH_LOGIN,
    PATH_USERS,
    PATH_REFRESH_TOKEN,
    PATH_USERS_CHECK,
    SECURITY_CLIENT_ANY,
    SECURITY_ROLE_ADMIN,
    SECURITY_ROLE_OWNER, PATH_USERS_PASSWORD_RESET, PATH_USERS_PASSWORD_FORGOT, PATH_CHANGE_PASSWORD, PATH_EXPORT
} from '../constants/constants';
import {download, getFiltersAsQuery, getFingerPrint, request, run} from "./APIService";

export function isAuthenticated() {
    return localStorage.getItem(DATA_ACCESS_TOKEN) && localStorage.getItem(DATA_USER_DATA_KEY);
}

export function getUserData() {
    return JSON.parse(localStorage.getItem(DATA_USER_DATA_KEY));
}

export function getUserClients() {
    const profile = getUserData();
    if (profile) {
        return profile.clients;
    } else {
        return [];
    }
}

export function isAdminRole() {
    return isAdmin(getUserData());
}

export function isOwnerRole(client) {
    return isOwner(getUserData(), client);
}

export function login(loginRequest) {
    return getFingerPrint().then(response => {
        loginRequest.fingerPrint = response;
        loginRequest.fingerPrint.data.properties = getUserLoginProperties();
        return request({
            url: API_BASE_URL + PATH_LOGIN,
            method: 'POST',
            body: JSON.stringify(loginRequest)
        }, [403])
    });
}

export function logout() {
    localStorage.removeItem(DATA_ACCESS_TOKEN);
    localStorage.removeItem(DATA_USER_DATA_KEY);
}

export function refreshToken() {
    run({
        url: API_BASE_URL + PATH_REFRESH_TOKEN,
        method: 'POST'
    }, [400, 401, 403, 404, 406, 500]).then(response => {
        if (response.ok) {
            response.text().then(text => {
                localStorage.setItem(DATA_ACCESS_TOKEN, text);
            })
        }
    });
}

export function setUserData(user) {
    localStorage.setItem(DATA_USER_DATA_KEY, JSON.stringify(user));
}

export function saveUserDetails(userdetails) {
    localStorage.setItem(DATA_ACCESS_TOKEN, userdetails.token);
    setUserData(userdetails);
    if (userdetails.properties) {
        let properties = userdetails.properties;
        Object.keys(properties).forEach(key => localStorage.setItem("P_" + key, properties[key]))
    }
}

export function getUsers(page, size, filters, client) {
    return request({
        url: API_BASE_URL + PATH_USERS + '?page=' + page
            + '&order=email:ASC&clients.' + client + '&size=' + size
            + '&q=' + getFiltersAsQuery(filters) + "&clientId=" + client,
        method: 'GET'
    }, []);
}

export function exportUsers(filters, client) {
    return download({
        url: API_BASE_URL + PATH_USERS + PATH_EXPORT + '?order=email:ASC&clients.' + client +
            '&q=' + getFiltersAsQuery(filters) + "&clientId=" + client,
        method: 'GET',
        fileName: client + '-users.csv'
    }, []);
}

export function deleteUser(id, client) {
    return run({
        url: API_BASE_URL + PATH_USERS + '/' + id + "?clientId=" + client,
        method: 'DELETE'
    }, []);
}

export function updateUser(user, client) {
    if (user.clients[client]["role"] === SECURITY_ROLE_OWNER) {
        user.clients[client].groups = [];
        user.clients[client].actions = [];
    }
    if (user.id) {
        return request({
            url: API_BASE_URL + PATH_USERS + "/" + user.id + "?clientId=" + client,
            method: 'PUT',
            body: JSON.stringify(user)
        }, []);
    } else {
        user.id = user.email;
        return request({
            url: API_BASE_URL + PATH_USERS,
            method: 'POST',
            body: JSON.stringify(user)
        }, []);
    }
}

export function checkUserByEmail(email, client) {
    return request({
        url: API_BASE_URL + PATH_USERS + PATH_USERS_CHECK + email + "?clientId=" + client,
        method: 'GET'
    }, []);
}

export function resetPasswordForgot(email) {
    return request({
        url: API_BASE_URL + PATH_USERS + PATH_USERS_PASSWORD_FORGOT,
        method: 'POST',
        body: JSON.stringify({'email': email})
    }, []);
}

export function resetPassword(email, code) {
    return request({
        url: API_BASE_URL + PATH_USERS + PATH_USERS_PASSWORD_RESET,
        method: 'POST',
        body: JSON.stringify({'userId': email, 'token': code})
    }, []);
}

export function resetUserPassword(user, client) {
    return request({
        url: API_BASE_URL + PATH_USERS + PATH_USERS_PASSWORD_RESET + "/" + user.id + "?clientId=" + client,
        method: 'POST'
    }, []);
}

export function changeUserPassword(userId, currentPassword, pass) {
    const changeUserPassword = {userId: userId, oldPass: currentPassword, pass: pass};
    return request({
        url: API_BASE_URL + PATH_USERS + "/" + userId + PATH_CHANGE_PASSWORD,
        method: 'POST',
        body: JSON.stringify(changeUserPassword)
    }, []);
}

export function validatePass(pass) {
    if (pass.length < 8) {
        return {
            validateStatus: 'error',
            errorMsg: 'La contraseña debe tener mínimo 8 caracteres',
            errorMsgArgs: {"PASSWORD_MIN_LENGTH": 8}
        }
    } else {
        return {
            validateStatus: 'success',
            errorMsg: null,
        };
    }
}

export function validateConfirmPass(pass, originalPassword) {
    if (pass && originalPassword && pass !== originalPassword) {
        return {
            validateStatus: 'error',
            errorMsg: 'Las contraseñas no coinciden'
        }
    } else {
        return {
            validateStatus: 'success',
            errorMsg: null,
        };
    }
}

/*************************************************************/
/******************** private ********************************/
/*************************************************************/
function hasRole(user, client, role) {
    return user && user.clients && Object.keys(user.clients)
        .filter(x => x === client)
        .map(x => user.clients[x])
        .filter(x => x.role === role).length;
}

function isAdmin(user) {
    return hasRole(user, SECURITY_CLIENT_ANY, SECURITY_ROLE_ADMIN);
}

function isOwner(user, client) {
    if (user === undefined) {
        user = getUserData();
    }
    return user && user.clients && user.clients[client] && user.clients[client].role === SECURITY_ROLE_OWNER;
}

function getUserLoginProperties() {
    return Object.keys(localStorage).filter(key => key.startsWith("P_")).map(key => {
        return {"key": key, "value": localStorage[key]}
    });
}


// WEBPACK FOOTER //
// ./src/app/services/UsersService.js